import { Box, IconButton, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useFetch from '../../api/useFetch';
import { tokens } from '../../global/theme/tokens';
import BookmarkIcon from '@mui/icons-material/Bookmark';

export const ApplyProjectPreset = ({
  presetType,
  relations = [],
  onApply,
  onClose,
}) => {
  const { t } = useTranslation();
  const { apiData } = useFetch(`${presetType}-presets`);

  function handleSelect(preset) {
    onApply({ presetId: preset.id, relations });
    onClose();
  }

  return (
    <Box className="flex flex-col gap-2 w-full p-2 max-h-[75vh]">
      <Typography variant="h3" className="mb-2">
        {t('Select Preset')}
      </Typography>
      <Box className="flex flex-col gap-2 overflow-y-auto pr-1">
        {apiData &&
          apiData.data.map((preset) => (
            <PresetItem
              key={preset.id}
              preset={preset}
              onSelect={handleSelect}
            />
          ))}
      </Box>
    </Box>
  );
};

const PresetItem = ({ preset, onSelect }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  return (
    <Box
      onClick={() => onSelect(preset)}
      className="p-2 rounded-lg flex flex-row gap-2 backdrop-blur-lg items-center cursor-pointer"
      sx={{
        bgcolor: colors.card,
        border: '1px solid transparent',
        '&:hover': {
          bgcolor: colors.info + '30',
          borderColor: colors.info + '80',
        },
      }}
    >
      {preset?.icon ? (
        <img
          src={preset.icon.temporaryUrl}
          alt={`${preset.title} icon`}
          className="w-8 h-8 object-contain"
        />
      ) : (
        <IconButton>
          <BookmarkIcon />
        </IconButton>
      )}

      <Box className="flex flex-col gap-1">
        <Typography>{preset.title}</Typography>
        {preset.data?.name && (
          <Typography variant="h6">{preset.data.name}</Typography>
        )}
      </Box>
    </Box>
  );
};
